import { Text } from '@cad-arc';
import { DataPrivacy } from '../common/components/datadog-privacy';

export function SectionTitle({ title, unmask = false }: { title: string; unmask?: boolean }) {
    // Opt-in unmasking of the (PII-free) section label for Datadog Session Replay.
    // Default (unmask=false) → `passthrough`, leaving the title masked by the global replay default.
    const privacy = unmask ? 'unmask' : 'passthrough';
    return (
        <DataPrivacy privacy={privacy}>
            <Text as="b" fontSize="large" color="tertiary">
                {title}
            </Text>
        </DataPrivacy>
    );
}
